import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

import { AuthContext, base_url } from "./Authcontext";
import { useRef } from "react";

export const AdminNotificationContext = createContext();

export const AdminNotificationProvider = ({ children }) => {
  const [withdrawList, setWithdraw] = useState(null);
  const [totalRecharge, setTotalRecharge] = useState(null);
  const [permit, setPermit] = useState([]);

  const { getRoles } = useContext(AuthContext);

  // console.log("totalRecharge:", totalRecharge);

  // const showNotification = (title, body) => {
  //   if (Notification.permission === "granted") {
  //     navigator.serviceWorker.getRegistration().then((reg) => {
  //       if (reg) {
  //         reg.showNotification(title, {
  //           body,
  //           icon: "/logo192.png",
  //         });
  //       }
  //     });
  //   }
  // };

  const showNotification = (title, body, icon,url) => {
    if (Notification.permission === "granted") {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg) {
          reg.showNotification(title, {
            body,
            icon,
            data: {
              url
            },
          });
        }
      });
    }
  };

  //   BrowseWithdraw
  // useEffect(() => {
  //   const fetchWithdrawlList = async () => {
  //     try {
  //       const auth = localStorage.getItem("admin");
  //       const res = await axios.get(`${base_url}/api/webapi/withdraw/pending`, {
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `${auth}`,
  //         },
  //       });
  //       if (res.data.status) {
  //         setWithdraw(res.data.withdrawList);
  //       }
  //     } catch (err) {
  //       console.log("Error fetching withdrawal list:", err);
  //       // toast.error("Failed to load withdrawal data");
  //     }
  //   };

  //   fetchWithdrawlList();
  //   // fetchRoles();
  // }, []);

  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");
    // console.log('auth:',auth);
    // console.log('role:',role);
    
    

    try {
      const roles = await getRoles(auth, role);

      roles.map((role) => {
        const values = Object.values(role);

        values[0].map((val) => {
          if (Object.keys(val).includes("pending recharge")) {
            const permit = Object.values(val);
            setPermit(permit[0]);
          }
        });
      });
    } catch (error) {
      console.log("ert", error);
    }
  };


  const prevRechargeLength = useRef(0);

  // console.log("prevRechargelength", prevRechargeLength);

  useEffect(() => {
    let isInitialFetch = true;

    const fetchRechargeRecord = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const res = await axios.get(
          `${base_url}/api/webapi/admin/recharge/pending`,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              Authorization: `${auth}`,
            },
          }
        );

        const newRechargeList = res.data.list;

        if (
          !isInitialFetch &&
          newRechargeList?.length > prevRechargeLength.current
        ) {
          showNotification(
            "New Recharge Request",
            "You have a new recharge pending!",
            "/favicon.ico",
            "/admin/browse_recharge"
          );
        }

        prevRechargeLength.current = newRechargeList?.length;
        setTotalRecharge(newRechargeList);
      } catch (err) {
        console.log("Error fetching recharge list:", err);
      }
    };

    fetchRechargeRecord();
    fetchRoles();

  }, []);
  return (
    <AdminNotificationContext.Provider
      value={{
        withdrawList,
        setWithdraw,
        totalRecharge,
        setTotalRecharge,
        permit,
      }}
    >
      {children}
    </AdminNotificationContext.Provider>
  );
};
